"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientMeterIndexEligibilityService = exports.fetchRequestTrackingService = exports.updateOverconsumptionThresholdService = exports.updateTranquilityStatusService = exports.updateResidualLeakStatusService = exports.downloadProofDocumentService = exports.fetchClientWorkOrdersServiceV2 = exports.fetchClientWorkOrdersService = exports.fetchCombinedDeliveryPointByIdService = exports.fetchAlertsService = exports.fetchOverConsumptionAlertsService = exports.sendMeterReadingService = exports.sendMeterReadingPictureService = exports.fetchLastMeterService = exports.fetchdeliveryPointsListByProductContractIdService = exports.fetchDeliveryPointByIdService = void 0;
var index_1 = require("../index");
var deliveryPoint_1 = __importDefault(require("../models/deliveryPoint"));
var clientWorkOrder_1 = __importDefault(require("../models/clientWorkOrder"));
var axiosInstance_1 = __importDefault(require("../helper/axiosInstance"));
var overConsumptionAlert_1 = __importDefault(require("../models/overConsumptionAlert"));
var i18n_1 = __importDefault(require("../i18n"));
var common_1 = require("./common");
var ClientWorkOrders_1 = __importDefault(require("../models/ClientWorkOrders"));
function fetchClientWorkOrdersService(deliveryPointId, token, lang) {
    return __awaiter(this, void 0, void 0, function () {
        var config, translation, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    translation = (0, i18n_1.default)(lang);
                    route = "/section_subscriptions/".concat(deliveryPointId, "/client_workorders");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.HISTORY_INTERVENTION).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data.map(function (d) { return new clientWorkOrder_1.default(d, translation); })];
            }
        });
    });
}
exports.fetchClientWorkOrdersService = fetchClientWorkOrdersService;
function fetchClientWorkOrdersServiceV2(deliveryPointId, token, lang) {
    return __awaiter(this, void 0, void 0, function () {
        var config, translation, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    translation = (0, i18n_1.default)(lang);
                    route = "/v2/section_subscriptions/".concat(deliveryPointId, "/client_workorders");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.HISTORY_INTERVENTION).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new ClientWorkOrders_1.default(response.data, translation)];
            }
        });
    });
}
exports.fetchClientWorkOrdersServiceV2 = fetchClientWorkOrdersServiceV2;
function fetchDeliveryPointByIdService(sectionSubscriptionId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/section_subscriptions/".concat(sectionSubscriptionId, "/delivery_points");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new deliveryPoint_1.default(response.data)];
            }
        });
    });
}
exports.fetchDeliveryPointByIdService = fetchDeliveryPointByIdService;
function fetchdeliveryPointsListByProductContractIdService(productContractId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, path, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/deli/productcontract/".concat(productContractId, "/deliverypoints");
                    path = "".concat(index_1.urlsConfig.values.BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(path, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data.map(function (el) { return new deliveryPoint_1.default(el); })];
            }
        });
    });
}
exports.fetchdeliveryPointsListByProductContractIdService = fetchdeliveryPointsListByProductContractIdService;
/**
 * retourner la derniere valeur du compteur
 * @param token Token d'authentification Keycloak
 * @param sectionSubsciptionId l'id du rubrique qui lie l'utilisateur et le point de fourniture
 */
function fetchLastMeterService(sectionSubsciptionId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    url = "".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL, "/section_subscriptions/").concat(sectionSubsciptionId, "/meter_indexes/last");
                    return [4 /*yield*/, axiosInstance_1.default.get(url, config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.fetchLastMeterService = fetchLastMeterService;
function fetchOverConsumptionAlertsService(sectionsubscriptionId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, response, dataList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = "/sectionsubscription/".concat(sectionsubscriptionId, "/alert");
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    url = "".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(url, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    dataList = response.data.map(function (el) { return new overConsumptionAlert_1.default(el); });
                    return [2 /*return*/, dataList.sort(function (a, b) {
                            return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
                        })];
            }
        });
    });
}
exports.fetchOverConsumptionAlertsService = fetchOverConsumptionAlertsService;
/**
 * Récupérer les alertes de surConsommation, de fuites résiduelle  et de tranquillité avec leur paramètrages
 * @param token Token d'authentification Keycloak
 * @param origin Token d'authentification Keycloak
 * @param sectionsubscriptionId id de branchement
 */
function fetchAlertsService(sectionsubscriptionId, token, origin) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (origin) {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token),
                                Origin: origin
                            }
                        };
                    }
                    else {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token)
                            }
                        };
                    }
                    route = "/v2/sectionsubscription/".concat(sectionsubscriptionId, "/alert");
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    url = "".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(url, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.fetchAlertsService = fetchAlertsService;
/**
 * Activer/désactiver les alertes des fuites résiduelles
 * @param token Token d'authentification Keycloak
 * @param sectionsubscriptionId id de branchement
 * @residualLeakServiceStatus statut
 */
function updateResidualLeakStatusService(sectionSubscriptionId, residualLeakServiceStatus, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = '/sectionsubscription/residual_leak_activation';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), {
                            sectionSubscriptionId: sectionSubscriptionId,
                            residualLeakServiceStatus: residualLeakServiceStatus
                        }, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.updateResidualLeakStatusService = updateResidualLeakStatusService;
/**
 * Activer/désactiver les alertes des fuites résiduelles
 * @param token Token d'authentification Keycloak
 * @param sectionsubscriptionId id de branchement
 * @durationThresholdInDays duration
 * @volumeThresholdInL volume
 */
function updateOverconsumptionThresholdService(sectionSubscriptionId, durationThresholdInDays, volumeThresholdInL, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = '/sectionsubscription/over_consumption_threshold_setup';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), {
                            sectionSubscriptionId: sectionSubscriptionId,
                            durationThresholdInDays: durationThresholdInDays,
                            volumeThresholdInL: volumeThresholdInL
                        }, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.updateOverconsumptionThresholdService = updateOverconsumptionThresholdService;
/**
 * Activer/désactiver les alertes de tranquillité
 * @param token Token d'authentification Keycloak
 * @param sectionsubscriptionId id de branchement
 * @tranquilityAlertStatus statut
 */
function updateTranquilityStatusService(sectionSubscriptionId, tranquilityAlertStatus, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = '/sectionsubscription/tranquility_activation';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), {
                            sectionSubscriptionId: sectionSubscriptionId,
                            tranquilityAlertStatus: tranquilityAlertStatus
                        }, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.updateTranquilityStatusService = updateTranquilityStatusService;
/**
 * Envoyer la photo à notre api pour un envoi à SmartStorage
 * @param token Token d'authentification Keycloak
 * @param pictureData Données de la photo au format FormData
 */
function sendMeterReadingPictureService(pictureData, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, url, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'multipart/form-data',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    url = "".concat(index_1.urlsConfig.values.BASE_URL, "/deli/meterindex/upload");
                    return [4 /*yield*/, axiosInstance_1.default.post(url, pictureData, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, true];
                case 3:
                    e_1 = _a.sent();
                    throw e_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.sendMeterReadingPictureService = sendMeterReadingPictureService;
/**
 * Envoi du nouvel index
 * @param meterPayload Le nouvel index renseigné par le client
 * @param token Token keycloak pour l'authentification
 */
function sendMeterReadingService(meterPayload, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = "/meter_indexes";
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    url = "".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.post(url, meterPayload, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.sendMeterReadingService = sendMeterReadingService;
function fetchCombinedDeliveryPointByIdService(sectionSubscriptionId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/section_subscriptions/".concat(sectionSubscriptionId, "/supply_areas/delivery_points");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new deliveryPoint_1.default(response.data)];
            }
        });
    });
}
exports.fetchCombinedDeliveryPointByIdService = fetchCombinedDeliveryPointByIdService;
function downloadProofDocumentService(sectionSubscriptionId, token, origin) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    if (origin) {
                        config = {
                            headers: { Authorization: "Bearer ".concat(token), Origin: origin }
                        };
                    }
                    else {
                        config = { headers: { Authorization: "Bearer ".concat(token) } };
                    }
                    route = "/users/proofofaddress?sectionSubscriptionID=".concat(sectionSubscriptionId);
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
            }
        });
    });
}
exports.downloadProofDocumentService = downloadProofDocumentService;
function fetchRequestTrackingService(requestTrackingId) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, response, _b, requestId, supplyRequestSteps;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: {} };
                    route = "/supply_requests/".concat(requestTrackingId);
                    url = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(url, config)];
                case 1:
                    response = _c.sent();
                    (0, common_1.LogRequestResponse)(response);
                    _b = (_a = response.data) !== null && _a !== void 0 ? _a : {}, requestId = _b.requestId, supplyRequestSteps = _b.supplyRequestSteps;
                    return [2 /*return*/, {
                            requestId: requestId,
                            steps: supplyRequestSteps.map(function (_a) {
                                var stepOrder = _a.stepOrder, stepName = _a.stepName, stepStatus = _a.stepStatus, realizationDate = _a.realizationDate;
                                return ({
                                    rank: stepOrder,
                                    date: realizationDate,
                                    title: stepName,
                                    status: stepStatus ? 'DONE' : 'NEXT_STEP'
                                });
                            })
                        }];
            }
        });
    });
}
exports.fetchRequestTrackingService = fetchRequestTrackingService;
function getClientMeterIndexEligibilityService(clientId, origin, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    if (origin) {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token),
                                Origin: origin
                            }
                        };
                    }
                    else {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token),
                            }
                        };
                    }
                    route = "/section_subscriptions/".concat(clientId, "/meter_indexes/request_status");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.status];
            }
        });
    });
}
exports.getClientMeterIndexEligibilityService = getClientMeterIndexEligibilityService;
